export const environment = {
  production: true,
  backendUrl: '',
  apiUrl: '/api',
  visualizerApiBaseUrl: '/visualizer'
};
